import { MakeLogicType, actions, kea, listeners, path, reducers } from 'kea'
import posthog from 'posthog-js'

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface logsViewerSettingsLogicValues {
    prettifyJson: boolean
    timezone: string
    wrapBody: boolean
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface logsViewerSettingsLogicActions {
    setPrettifyJson: (prettifyJson: boolean) => {
        prettifyJson: boolean
    }
    setTimezone: (timezone: string) => {
        timezone: string
    }
    setWrapBody: (wrapBody: boolean) => {
        wrapBody: boolean
    }
}

export type logsViewerSettingsLogicType = MakeLogicType<logsViewerSettingsLogicValues, logsViewerSettingsLogicActions>

// Shared logic for user preferences which should be used across all tabs+windows
export const logsViewerSettingsLogic = kea<logsViewerSettingsLogicType>([
    path(['products', 'logs', 'frontend', 'components', 'LogsViewer', 'logsViewerSettingsLogic']),

    actions({
        // Timezone (IANA string, e.g. "UTC", "America/New_York")
        setTimezone: (timezone: string) => ({ timezone }),

        // Display options
        setWrapBody: (wrapBody: boolean) => ({ wrapBody }),
        setPrettifyJson: (prettifyJson: boolean) => ({ prettifyJson }),
    }),

    reducers(({}) => ({
        // Timezone selection (IANA string, persisted)
        timezone: [
            'UTC',
            { persist: true },
            {
                setTimezone: (_, { timezone }) => timezone,
            },
        ],

        wrapBody: [
            true,
            { persist: true },
            {
                setWrapBody: (_, { wrapBody }) => wrapBody,
            },
        ],

        // Not persisted: no toolbar control anymore; avoid stale localStorage. Default off — use row FAB / p to prettify per row.
        prettifyJson: [
            false,
            {
                setPrettifyJson: (_, { prettifyJson }) => prettifyJson,
            },
        ],
    })),

    listeners(() => ({
        setTimezone: ({ timezone }) => {
            posthog.capture('logs setting changed', { setting: 'timezone', value: timezone })
        },
        setWrapBody: ({ wrapBody }) => {
            posthog.capture('logs setting changed', { setting: 'wrap_body', value: wrapBody })
        },
    })),
])
